/* eslint-disable no-undef */
import {
    API,
    SITE_API,
    EMAIL_GET_ALL_SENTMAIL_URL,
    EMAIL_SEND_EMAIL_URL,
    EMAIL_GET_ALL_INBOX_URL,
    EMAIL_DELETE_INBOX_URL,
    EMAIL_SEND_NEW_EMAIL_URL,
    EMAIL_UPDATE_EMAIL_URL,
    EMAIL_SAVE_AS_NEW_DRAFT_URL,
    EMAIL_UPDATE_DRAFT_URL,
} from "../variable";

import axios from 'axios'
import {
    EMAIL_GET_ALL_SENTMAIL,
    EMAIL_SEND_EMAIL,
    EMAIL_GET_ALL_INBOX,
    EMAIL_DELETE_INBOX,
    EMAIL_SEND_NEW_EMAIL,
    EMAIL_UPDATE_EMAIL,
    EMAIL_SAVE_AS_NEW_DRAFT,
    EMAIL_UPDATE_DRAFT,
} from "../Actions/email.js";

const state = {

};

const actions = {
    [EMAIL_GET_ALL_SENTMAIL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + EMAIL_GET_ALL_SENTMAIL_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
    [EMAIL_SEND_EMAIL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + EMAIL_SEND_EMAIL_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
    [EMAIL_GET_ALL_INBOX]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: payload.initialData ? SITE_API + EMAIL_GET_ALL_INBOX_URL : SITE_API + EMAIL_GET_ALL_INBOX_URL + "?pageToken=" + payload.pageToken,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
    [EMAIL_DELETE_INBOX]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + EMAIL_DELETE_INBOX_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
    [EMAIL_SEND_NEW_EMAIL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + EMAIL_SEND_NEW_EMAIL_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
    [EMAIL_UPDATE_EMAIL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + EMAIL_UPDATE_EMAIL_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
    [EMAIL_SAVE_AS_NEW_DRAFT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + EMAIL_SAVE_AS_NEW_DRAFT_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
    [EMAIL_UPDATE_DRAFT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + EMAIL_UPDATE_DRAFT_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken },
        });
    },
};

const mutations = {};

const getters = {};

export default {
    state,
    getters,
    actions,
    mutations
};